/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurableParameterDto } from './ConfigurableParameterDto';
import {
    ConfigurableParameterDtoFromJSON,
    ConfigurableParameterDtoFromJSONTyped,
    ConfigurableParameterDtoToJSON,
    ConfigurableParameterDtoToJSONTyped,
} from './ConfigurableParameterDto';

/**
 * 
 * @export
 * @interface FeesDto
 */
export interface FeesDto {
    /**
     * 
     * @type {string}
     * @memberof FeesDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FeesDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof FeesDto
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof FeesDto
     */
    value: number;
    /**
     * 
     * @type {ConfigurableParameterDto}
     * @memberof FeesDto
     */
    parameters?: ConfigurableParameterDto;
    /**
     * 
     * @type {string}
     * @memberof FeesDto
     */
    warningMessage?: string;
    /**
     * Affichage du frais sur la page de tarification (le frais reste compté dans le prix).
     * @type {boolean}
     * @memberof FeesDto
     */
    displayedOnPricing?: boolean;
}

/**
 * Check if a given object implements the FeesDto interface.
 */
export function instanceOfFeesDto(value: object): value is FeesDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function FeesDtoFromJSON(json: any): FeesDto {
    return FeesDtoFromJSONTyped(json, false);
}

export function FeesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'label': json['label'],
        'value': json['value'],
        'parameters': json['parameters'] == null ? undefined : ConfigurableParameterDtoFromJSON(json['parameters']),
        'warningMessage': json['warningMessage'] == null ? undefined : json['warningMessage'],
        'displayedOnPricing': json['displayedOnPricing'] == null ? undefined : json['displayedOnPricing'],
    };
}

export function FeesDtoToJSON(json: any): FeesDto {
    return FeesDtoToJSONTyped(json, false);
}

export function FeesDtoToJSONTyped(value?: FeesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'label': value['label'],
        'value': value['value'],
        'parameters': ConfigurableParameterDtoToJSON(value['parameters']),
        'warningMessage': value['warningMessage'],
        'displayedOnPricing': value['displayedOnPricing'],
    };
}

